import React from "react";

import {useAppCtx} from "../app/AppCtx";
import {CxGrid} from "../cmx/CxGrid";
import {CxTitle, CxSubtitle} from "../cmx/CxTypography";
import {CxRadioSelection} from "../cmx/CxSelection";
import {CxButton} from "../cmx/CxButton";

// --------------------------------------------------------------------------------------------------------------------
// Grid's
// --------------------------------------------------------------------------------------------------------------------

function Grid1({title}) {
    return (
        <CxGrid size="xl">
            { title }
        </CxGrid>
    );
};

function Grid2({title, actions}) {
    return (
        <>
            <CxGrid size="lg">
                { title }
            </CxGrid>

            <CxGrid size="lg" align="right" sx={{gap: 2}}>
                { actions }
            </CxGrid>
        </>
    );
};

function Grid3({title, views, actions}) {
    return (
        <CxGrid container direction="row" spacing={1} alignItems="center">
            <CxGrid size="md">
                { title }
            </CxGrid>

            <CxGrid size="md" align="center">
                { views }
            </CxGrid>

            <CxGrid size="md" align="right" sx={{gap: 2}}>
                { actions }
            </CxGrid>
        </CxGrid>
    );
};

// --------------------------------------------------------------------------------------------------------------------
// Render elements
// --------------------------------------------------------------------------------------------------------------------

function renderTitle ({title, isSubtitle}) {

    if (isSubtitle) {
        return <CxSubtitle>{title}</CxSubtitle>
    }

    return <CxTitle>{title}</CxTitle>
}


function renderSelection ({viewItems, viewInitialValue, viewOnChangeHandler}) {
    return (
        <CxRadioSelection
            name="selection"
            radioItems={viewItems}
            initialValue={viewInitialValue}
            onChange={viewOnChangeHandler}
        />
    );
}


function renderGlobalActions({actionItems, handleAction}) {
    return (
        <>
            { actionItems.map((item, index) => (
                <CxButton
                    key={index}
                    kind={item.kind}
                    label={item.label}
                    iconName={item.iconName}
                    disabled={item.disabled}
                    onClick={() => handleAction(item.actionName)}
                />
            ))}
        </>
    );
}


function renderLocalActions({localActionItems, localActionOnChangeHandler}) {
    return (
        <>
            { localActionItems.map((item, index) => (
                <CxButton
                    key={index + 100}
                    kind={item.kind}
                    label={item.label}
                    iconName={item.iconName}
                    disabled={item.disabled}
                    onClick={() => localActionOnChangeHandler(item.actionName)}
                />
            ))}
        </>
    );
}


function renderActions({localActionItems, localActionOnChangeHandler, actionItems, handleAction}) {

    if (localActionItems === null) {
        return renderGlobalActions({actionItems, handleAction})

    } else if (actionItems === null) {
        return renderLocalActions({localActionItems, localActionOnChangeHandler})
    }

    return (
        <>
            { renderLocalActions({localActionItems, localActionOnChangeHandler}) }
            { renderGlobalActions({actionItems, handleAction}) }
        </>
    );
}

// --------------------------------------------------------------------------------------------------------------------
// Page header
// --------------------------------------------------------------------------------------------------------------------

export function PageHeader ({
    title, isSubtitle= false,
    viewItems= null, viewInitialValue= null, viewOnChangeHandler = null,
    localActionItems = null,  localActionOnChangeHandler = null,  actionItems = null} ){

    const {handleAction} = useAppCtx();

    if (viewItems === null && localActionItems === null && actionItems === null) {
        return (
            <Grid1
                title={ renderTitle({title, isSubtitle}) }
            />
        );

    } else if (viewItems === null) {
        return (
            <Grid2
                title={ renderTitle({title, isSubtitle}) }
                actions={ renderActions({localActionItems, localActionOnChangeHandler, actionItems, handleAction}) }
            />
        );

    }

    return (
        <Grid3
            title={ renderTitle({title, isSubtitle}) }
            views={ renderSelection({viewItems,viewInitialValue, viewOnChangeHandler}) }
            actions={ renderActions({localActionItems, localActionOnChangeHandler, actionItems, handleAction}) }
        />
    );

}

export function PageHeaderItems ({title, isSubtitle= false, viewItems= null, actionItems = null}) {

    if (viewItems === null && actionItems === null) {
        return <Grid1 title={renderTitle({title, isSubtitle})}/>
    }

    if (viewItems === null) {
        return <Grid2 title={renderTitle({title, isSubtitle})} actions={actionItems} />
    }

    return <Grid3 title={renderTitle({title, isSubtitle})} views={viewItems} actions={actionItems} />
}

// --------------------------------------------------------------------------------------------------------------------
// The end.
